export enum BuildingTypeGroups {
  commercialLand = 'commercial_land',
  hospitality = 'hospitality',
  industrial = 'industrial',
  licensedAndLeisure = 'licensed_and_leisure',
  office = 'office',
  other = 'other',
  residential = 'residential',
  retail = 'retail',
  rural = 'rural',
}

export enum AtlasBuildingTypeGroups {
  industrial = 'industrial',
  land = 'land',
  leisure = 'leisure',
  office = 'office',
  other = 'other',
  retail = 'retail',
}
